import http from '@/utils/http'
/**
 * 获取校园列表
 */
export function getPrCompus(data) {
    return http({
        url: '/province/compus/paging',
        method: 'post',
        data
    })
}

/**
 * 获取需要绑定的主体
 * @param data
 * @returns {AxiosPromise}
 */
export function getCompusBindEntity(data){
    return http({
        url:"/province/compus/pagingEntity",
        method: 'post',
        data
    })
}

/**
 * 绑定校区
 * @param data
 * @returns {AxiosPromise}
 */
export function bindCompus(data){
    return http({
        url:"/province/compus/bind",
        method: 'post',
        data
    })
}

/**
 * 主体和校区解绑
 * @param data
 * @returns {AxiosPromise}
 */
export function unBindCompus(data){
    return http({
        url:"/province/compus/unbind",
        method: 'post',
        params: data
    })
}

/**
 * 获取食堂列表
 * @param params
 * @returns {AxiosPromise}
 */
export  function getDinningRoom(data){
    return http({
        url:"/province/diningRoom/paging",
        method: 'post',
        data
    })
}

/**
 * 待绑定食堂列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getDingRoomSubEntity(data){
    return http({
        url:"/province/diningRoom/pagingSubEntity",
        method: 'post',
        data
    })
}

/**
 * 绑定食堂
 * @param data
 * @returns {AxiosPromise}
 */
export function bindSubEntity(data){
    return http({
        url:"/province/diningRoom/bind",
        method: 'post',
        data
    })
}

/**
 * 解绑主体和食堂
 * @param data
 * @returns {AxiosPromise}
 */
export function unBindDiningRoom(data){
    return http({
        url:"/province/diningRoom/unbind",
        method: 'post',
        params: data
    })
}

/**
 * 获取用户列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getUsers(data){
    return http({
        url:"/province/user/paging",
        method: 'post',
        data
    })
}

/**
 * 获取带绑定员工列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getEmployees(data){
    return http({
        url:"/province/user/pagingEmployee",
        method: 'post',
        data
    })
}

/**
 * 绑定员工和主体
 * @param data
 * @returns {AxiosPromise}
 */
export function bindEmployees(data){
    return http({
        url:"/province/user/bind",
        method: 'post',
        data
    })
}

/**
 * 解绑员工和主体
 * @param data
 * @returns {AxiosPromise}
 */
export function unBindEmployee(data){
    return http({
        url:"/province/user/unbind",
        method: 'post',
        params: data
    })
}

/**
 * Tob待绑定供应商列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getSupplier(data) {
    return http({
        url: "/province/supplier/paging",
        method: 'post',
        data
    })
}

/**
 * Tob待绑定供应商列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getTobSupplier(data) {
    return http({
        url: "/province/supplier/pagingTobSupplier",
        method: 'post',
        data
    })
}

/**
 * 获取待绑定填报供应商列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getFillSupplier(data) {
    return http({
        url: "/province/supplier/pagingFillSupplier",
        method: 'post',
        data
    })
}

/**
 * 绑定tob供应商
 * @param data
 * @returns {AxiosPromise}
 */
export function bindTobSupplier(data) {
    return http({
        url: "/province/supplier/tobBind",
        method: 'post',
        data
    })
}

/**
 * 解绑tob供应商
 * @param data
 * @returns {AxiosPromise}
 */
export function unBindTobSupplier(data) {
    return http({
        url: "/province/supplier/tobUnbind",
        method: 'post',
        params: data
    })
}


/**
 * 绑定tob供应商
 * @param data
 * @returns {AxiosPromise}
 */
export function bindFillSupplier(data) {
    return http({
        url: "/province/supplier/fillBind",
        method: 'post',
        data
    })
}

/**
 * 解绑tob供应商
 * @param data
 * @returns {AxiosPromise}
 */
export function unBindFillSupplier(data) {
    return http({
        url: "/province/supplier/fillUnbind",
        method: 'post',
        params: data
    })
}
